import React from 'react';
import {ModeledUpliftSurveySection} from "./ModeledUpliftSurveySection";

// irrigation upgrades are synced from Fulcrum instead of being entered manually
// so this component exposes a read-only view even while editing
export const ModeledUpliftReadOnlySurveySection = (props) => {    
    return <ModeledUpliftSurveySection
        {...props}
        EditMode={false}
    />
}
